/** Theme switching. Three states, cycled: system -> light -> dark -> system. */

const STORAGE_KEY = "mdc-theme";
const ORDER = ["system", "light", "dark"];

const LABELS = {
  system: "Theme: following system. Switch to light.",
  light: "Theme: light. Switch to dark.",
  dark: "Theme: dark. Follow system.",
};

function currentTheme() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return ORDER.includes(stored) ? stored : "system";
}

const themeColorMetas = Array.from(
  document.querySelectorAll('meta[name="theme-color"]')
).map((el) => ({ el, authored: el.getAttribute("content") }));

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "system") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", theme);
  }

  if (theme === "system") {
    for (const { el, authored } of themeColorMetas) el.setAttribute("content", authored);
    return;
  }

  const canvas = getComputedStyle(root).getPropertyValue("--color-canvas").trim();
  if (!canvas) return;
  for (const { el } of themeColorMetas) el.setAttribute("content", canvas);
}

function syncControls(theme) {
  for (const el of document.querySelectorAll("[data-theme-toggle]")) {
    el.setAttribute("aria-label", LABELS[theme]);
    el.setAttribute("title", LABELS[theme]);
  }
}

function setTheme(theme) {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
  syncControls(theme);
}

export function initTheme() {
  document.documentElement.setAttribute("data-js", "");

  syncControls(currentTheme());

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-theme-toggle]");
    if (!toggle) return;
    event.preventDefault();
    const next = ORDER[(ORDER.indexOf(currentTheme()) + 1) % ORDER.length];
    setTheme(next);
  });

  window.addEventListener("storage", (event) => {
    if (event.key !== STORAGE_KEY) return;
    applyTheme(currentTheme());
    syncControls(currentTheme());
  });
}
